module.exports = __webpack_public_path__ + "static/media/inactive-bell.78ab667a.svg";